import "./ComplementaryReports.css";
import DatePicker from "../../components/UI/DatePicker/DatePicker";
import Search from "../../components/UI/Search/Search";
import Button from "../../components/UI/Button/Button";
import FetchData from "../../shared/fetchData";
import { useState } from "react";
import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import moment from 'moment-jalaali'

const ReportTwo = (props) => {
    const today = new Date()

    const [from, setFrom] = useState(moment(today).format('jYYYY/jMM/jDD'))
    const [to, setTo] = useState(moment(today).format('jYYYY/jMM/jDD'))
    const [loading, setLoading] = useState('')


    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getComplementaryReports2'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.orders.map(o => {
                        count++
                        exportOrderReport.push({
                            'نام لاکر': o.kiosk != null ? o.kiosk.description : '',
                            'شماره لاکر': o.kiosk != null ? o.kiosk.id : '',
                            "آدرس لاکر": o.kiosk != null ? o.kiosk.address : '',
                            "باکس لاکر": o.locker != null ? o.locker.serial : '',
                            "ساعت رزرو": o.registerTime,
                            "تاریخ رزرو": o.registerDate,
                            "استفاده از کد Load": o.inputPass,
                            'استفاده از کد Unload': o.outputPass,
                            "استفاده از کد General": o.generalPass,
                            "مشتری/ثبت کننده رزرو": o.unit != null ? o.unit.unitName : '',
                            "تاریخ و ساعت ثبت رکورد": o.registerDate + "-" + o.registerTime,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'report2' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const refresh = (event) => {
        setFrom('')
        setTo('')
    }
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }

    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const form = <>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 small-date-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="تاریخ ثبت سفارش از" />
            </div>
            <div className="col-3 small-date-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تاریخ ثبت سفارش تا" />
            </div>
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </>
    return (
        <>
            <Search class="cmplmnt-Search" form={form} />
            <div>

            </div>
        </>
    )
}

export default ReportTwo;